/**
 * True while scripts/prerender.js is snapshotting the page. Data hooks skip
 * their fetch so the static HTML keeps the same "loading" markup the client
 * renders first — otherwise React would hydrate against mock/empty data and
 * throw the snapshot away.
 */
export const isPrerendering = (): boolean =>
  typeof window !== "undefined" && Boolean((window as any).__PRERENDER__);
